export const OKTA_TOKEN_LOCALSTORAGE_KEY = 'okta-token-storage'

export const getPinnedMoments = async () => {
  try {
    const oktaCredentials = JSON.parse(
      localStorage.getItem(OKTA_TOKEN_LOCALSTORAGE_KEY) || '{}'
    )

    if (!oktaCredentials?.accessToken?.accessToken) {
      return []
    }

    const raw = await fetch(
      `${import.meta.env.VITE_BACKEND_URL}/api/pinned-moments`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${oktaCredentials?.accessToken?.accessToken}`
        }
      }
    )
    const response = await raw.json()

    return response?.nftIds ?? []
  } catch (error) {
    //add papertrail logging
    return []
  }
}

export const upsertPinnedMoments = async (ids: string[]) => {
  const oktaCredentials = JSON.parse(
    localStorage.getItem(OKTA_TOKEN_LOCALSTORAGE_KEY) || '{}'
  )

  if (!oktaCredentials?.accessToken?.accessToken) {
    return
  }
  const raw = await fetch(
    `${import.meta.env.VITE_BACKEND_URL}/api/pinned-moments`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${oktaCredentials?.accessToken?.accessToken}`
      },
      body: JSON.stringify({ nftIds: ids })
    }
  )
  const response = await raw.json()

  return response?.nftIds
}
